import React from 'react';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Row,
  Col,
} from 'reactstrap';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import { IconButton } from '@mui/material';
import format from 'date-fns/format';

function ViewStudent({ userInfo, onClose, packageInfo, packages }) {
  console.log('userinfo', userInfo, 'package', packages);
  return (
    <>
      {/* <div  style={{ width: '100%' }}>
        <Row style={{}}>
          <Col md="8"> */}
      <Card style={{ border: '2px solid white' }}>
        <CardHeader
          style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
          }}
        >
          <h5 className='title'>Student Info</h5>
          <span className='text-align-right' md='4'>
            <IconButton onClick={() => onClose(false)}>
              <CloseIcon style={{ color: '#FFF' }} />
            </IconButton>
          </span>
        </CardHeader>
        <CardBody>
          <Row>
            <Col className='pr-md-1' md='8'>
              <h3 style={{ marginBottom: 0 }}>Personal Info</h3>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>First Name</label>
                <h6>{userInfo?.firstname ? userInfo?.firstname : 'N/A'}</h6>
              </FormGroup>
            </Col>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Last Name</label>
                <h6>{userInfo?.lastname ? userInfo?.lastname : 'N/A'}</h6>
              </FormGroup>
            </Col>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Father Name</label>
                <h6>{userInfo?.fatherName ? userInfo?.fatherName : 'N/A'}</h6>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Husband's Name</label>
                <h6>{userInfo?.husbandName ? userInfo?.husbandName : 'N/A'}</h6>
              </FormGroup>
            </Col>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Mother Name</label>
                <h6>{userInfo?.motherName ? userInfo?.motherName : 'N/A'}</h6>
              </FormGroup>
            </Col>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Gender</label>
                <h6>{userInfo?.gender ? userInfo?.gender : 'N/A'}</h6>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Date of birth</label>
                <h6>
                  {userInfo?.dateofBirth
                    ? new Date(userInfo?.dateofBirth).toString() ===
                      'Invalid Date'
                      ? 'Invalid Date'
                      : format(new Date(userInfo?.dateofBirth), 'dd-MM-yyyy')
                    : 'N/A'}
                </h6>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md='4'>
              <h3 style={{ marginBottom: 0 }}>Contact Info</h3>
            </Col>
          </Row>
          <Row>
            <Col md='4'>
              <FormGroup>
                <label>Telephone No.</label>
                <h6>{userInfo?.mobile ? userInfo?.mobile : 'N/A'}</h6>
              </FormGroup>
            </Col>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Whatsapp No.</label>
                <h6>{userInfo?.whatsapp ? userInfo?.whatsapp : 'N/A'}</h6>
              </FormGroup>
            </Col>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Email </label>
                <h6>{userInfo?.email ? userInfo?.email : 'N/A'}</h6>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='8'>
              <FormGroup>
                <label>Address</label>
                <h6>{userInfo?.address ? userInfo?.address : 'N/A'}</h6>
              </FormGroup>
            </Col>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Pin Code</label>
                <h6>
                  {userInfo?.addresspinCode ? userInfo?.addresspinCode : 'N/A'}
                </h6>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='4'>
              <h3 style={{ marginBottom: 0 }}>Educational Details</h3>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Educational Qualification</label>
                <h6>
                  {userInfo?.educationalQualification
                    ? userInfo?.educationalQualification
                    : 'N/A'}
                </h6>
              </FormGroup>
            </Col>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Year of passing</label>
                <h6>
                  {userInfo?.educationalQualificationPassingYear?.seconds
                    ? isNaN(
                        new Date(
                          userInfo?.educationalQualificationPassingYear
                            ?.seconds * 1000
                        )
                      )
                      ? 'N/A'
                      : new Date(
                          userInfo?.educationalQualificationPassingYear
                            .seconds * 1000
                        ).getFullYear()
                    : userInfo?.educationalQualificationPassingYear
                    ? userInfo?.educationalQualificationPassingYear
                    : 'N/A'}
                </h6>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Professional Qualification</label>
                <h6>
                  {userInfo?.professionalQualification
                    ? userInfo?.professionalQualification
                    : 'N/A'}
                </h6>
              </FormGroup>
            </Col>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Year of passing</label>
                <h6>
                  {userInfo?.professionalQualificationPassingYear?.seconds
                    ? isNaN(
                        new Date(
                          userInfo?.professionalQualificationPassingYear
                            ?.seconds * 1000
                        )
                      )
                      ? 'N/A'
                      : new Date(
                          userInfo?.professionalQualificationPassingYear
                            .seconds * 1000
                        ).getFullYear()
                    : userInfo?.professionalQualificationPassingYear
                    ? userInfo?.professionalQualificationPassingYear
                    : 'N/A'}
                </h6>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='4'>
              <FormGroup>
                <label>Marks of CTET</label>
                <h6>{userInfo?.marksofCTET ? userInfo?.marksofCTET : 'N/A'}</h6>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='4'>
              <h3 style={{ marginBottom: 0 }}>Other Details</h3>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='8'>
              <FormGroup>
                <label>Category</label>
                <h6>{userInfo?.category ? userInfo?.category : 'N/A'}</h6>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className='pr-md-1' md='4'>
              <h3 style={{ marginBottom: 0 }}>Package Info</h3>
            </Col>
          </Row>

          {userInfo?.Courses ? (
            userInfo?.Courses?.map((item) => {
              let packageName = packages.find((fitem) => fitem.itemID === item);
              return (
                <>
                  <Col className='pr-md-1' md='4'>
                    <FormGroup>
                      <label>Package</label>
                      <h6>
                        {packageName && packageName !== -1
                          ? packageName?.title
                          : 'N/A'}
                      </h6>
                    </FormGroup>
                  </Col>
                  <Col className='pr-md-1' md='4'>
                    <FormGroup>
                      <label>Selected Shift</label>
                      <h6> {userInfo?.shift ? userInfo?.shift : 'N/A'}</h6>
                    </FormGroup>
                  </Col>
                </>
              );
            })
          ) : (
            <Row>
              <Col md='4' className='pr-md-1'>
                <h6>N/A</h6>
              </Col>
            </Row>
          )}

          {/* {userInfo?.shiftsSelected ?
                  Object.entries(userInfo?.shiftsSelected).map((userShift) => (
                    <Row>
                      <Col className="pr-md-1" md="8">
                        <h6>
                          {packageInfo ? packageInfo[userShift[0]] : "N/A"}
                        </h6>
                      </Col>
                      <Col className="pr-md-1" md="4">
                        <h6>{packageInfo ? userShift[1] : "N/A"}</h6>
                      </Col>
                    </Row>
                  )) : "N/A"} */}
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Button onClick={() => onClose(false)}>Close</Button>
          </div>
        </CardBody>
      </Card>
      {/* </Col>
        </Row> */}
      {/* </div> */}
    </>
  );
}

export default ViewStudent;
